module.exports = __webpack_public_path__ + "img/line-archive.23d8c060.svg";